export enum ThemeName {
  lager = 'lager',
  guinness = 'guinness'
}

export type ThemeNames = keyof typeof ThemeName
